import { Box, Button, TextField } from '@mui/material';
import { BoxFC, BoxFR } from 'components/BoxCustom';
import DataGridCellExpand from 'components/DataGridCellExpand/DataGridCellExpand';
import React, { useCallback, useState, useContext, useEffect, useMemo } from 'react';
import { addSumRow, getSumColorClassName, sxSumColorClass } from 'utils/highlightSumColor';
import { columns } from './columns';
import { GlobalStateContext } from 'contexts/GlobalStateContext';
import SearchButton from 'components/buttons/SearchButton';
import ClearButton from 'components/buttons/ClearButton';
import { initFilterData, clearFilterData } from './initData';
import { addIdForDataGrid } from 'utils';
import { DesktopDatePicker } from '@mui/x-date-pickers-pro';
import { branchApiNm } from 'branch/constant/branchApiNm';
import dayjs from 'dayjs';
import DriverSalaryMasterDialog from './DriverSalaryMasterDialog';
import { salaryDriverColNm } from './constant';
// import TextFieldDialog from 'components/dialog/TextFieldDialog';
import { red } from '@mui/material/colors';
import DriverSalaryDetailDialog from './DriverSalaryDetailDialog';
import ComboBox from 'components/ComboBox';
import AddButton from 'components/buttons/AddButton';
import AddDriverSalaryDialog from './AddDriverSalaryDialog';
import { GRID_CHECKBOX_SELECTION_COL_DEF } from '@mui/x-data-grid';
import { alertError } from 'components/Alert';
import { CalculateRounded } from 'resource/muiImport';

let selectedRow = null
let selectedField = null
let lastFilter = null

const DriverSalary = () => {
  const { ax, msData } = useContext(GlobalStateContext)
  const [dataTable, setDataTable] = useState([])
  const [selectionModel, setSelectionModel] = useState([])
  const [dialogDiverSalaryMasterOpen, setDialogDiverSalaryMasterOpen] = useState(false)
  // const [dialogTextFieldOpen, setDialogTextFieldOpen] = useState(false)
  const [filterData, setFilterData] = useState({ ...initFilterData })
  const [dialogDriverSalaryDetailOpen, setDialogDriverSalaryDetailOpen] = useState(false)
  const [dialogAddDriverSalaryOpen, setDialogAddDriverSalaryOpen] = useState(false)

  
  const monthPickerProp = useMemo(() => ({
    openTo: "month",
    views:["year", "month"],
    disableMaskedInput: true,
    label: salaryDriverColNm.SalDte,
    inputFormat: "MMMM YYYY",
    value: filterData.SalDte,
    onChange: (newValue) => { setFilterData(o => ({ ...o, SalDte: newValue })) },
    renderInput: (params) => <TextField size="small" {...params} sx={{ width: 160 }} />,

  }), [filterData.SalDte])

  const modDataTable = useMemo(() => {
    const result = addSumRow({
      dataTable: dataTable,
      sumColNms: ["SalAmnt", "TripAllAmnt", "IncAmnt1", "IncAmnt2", "IncAmnt3", "IncAmnt4" , "OthAmnt"
        ,"DeSecDepAmnt", "DeTfcFineAmnt", "DeSSAmnt", "DeOthAmnt", "DeAmnt1", "DeAmnt2"],
      sumColTotal: "DrvNm"
    })
    return result
  }, [dataTable])

  const getData = useCallback((filter) => {
    const postData = {
      ...filter,
      SalDte: dayjs(filter.SalDte).format("YYYY-MM-DD")
    }
    ax.post(branchApiNm.getDriverSalary, postData).then(value => {
      if (value.data) {
        lastFilter = filter
        setDataTable(addIdForDataGrid(value.data, 'DrvId'))
      }
    })
  }, [ax])

  // const handleGetDriverMaster = useCallback(() => {
  //   if (selectionModel.length === 0) {
  //     alertError("กรุณาเลือกพนักงานขับรถ")
  //     return
  //   }
  //   const postData = {
  //     DrvIds: selectionModel,
  //     SalDte: dayjs(filterData.SalDte).format("YYYY-MM-DD"),
  //     getArgs: {
  //       ...lastFilter,
  //       SalDte: dayjs(lastFilter.SalDte).format("YYYY-MM-DD")
  //     }
  //   }

  //   ax.post(branchApiNm.insertUpdateDrierSalaryFromMaster, postData).then(value => {
  //     if (value.data) {
  //       setDataTable(addIdForDataGrid(value.data, 'DrvId'))
  //     }
  //   })
  // }, [ax, selectionModel, filterData.SalDte])


  // const onTextFieldDialogFinish = useCallback((value) => {
    
  // }, [ax, selectionModel, filterData.SalDte])

  const handleCellClick = useCallback((params) => {
    selectedRow = params.row
    selectedField = params.field
    // if (["SalAmnt", "IncAmnt1", "IncAmnt2", "IncAmnt3", "OthAmnt", "OthDscp", "Rmk"
    //   , "DeSecDepAmnt", "DeSSPrct", "DeOthAmnt", "DeOthDscp", "DeTfcFineAmnt"].includes(params.field)) {
    //   setDialogTextFieldOpen(true)
    // } else 
    if (params.field === "ShowDetail") {
      setDialogDriverSalaryDetailOpen(true)
    }
  }, [])

  const onAddDialogFinish = useCallback((data) => {
    setDataTable(addIdForDataGrid(data, 'DrvId'))
  }, [])

  const handleAddDriverSalary = useCallback(() => {
    setDialogAddDriverSalaryOpen(true)
  }, [])

  const handleCellEditCommit = useCallback(({id, value}) => {
    const drvIds = selectionModel.includes(id) ? selectionModel : [id]
    const postData = {
      DrvIds: drvIds,
      SalDte: dayjs(filterData.SalDte).format("YYYY-MM-DD"),
      ColNm: selectedField,
      ColVal: value === "" ? null : value,
      getArgs: {
        ...lastFilter,
        SalDte: dayjs(lastFilter.SalDte).format("YYYY-MM-DD")
      }
    }
    ax.post(branchApiNm.inssertUpdateDriverSalary, postData, false).then(res => {
      if (res.data) {
        // setDataTable(addIdForDataGrid(value.data, 'DrvId'))
        setDataTable(o=>{
          return o.map(row=>{
            console.log("find")
            if(drvIds.includes(row.id)){
              console.log("found row----->::", row)
              return {...row, [selectedField]: value}
            }
            return row
          })
        })
      }
    })
  }, [filterData, selectionModel, ax])

  const handleAddDriverSalaryFromLastMonth = useCallback(() => {
    const postData = {
      SalDte: dayjs(filterData.SalDte).format("YYYY-MM-DD")
    }
    ax.post(branchApiNm.handleAddDriverSalaryFromLastMonth, postData).then(value=>{
      if(value.data){
        setDataTable(addIdForDataGrid(value.data, 'DrvId'))
      }
    })
  }, [ax, filterData.SalDte])
  
  const handleCalculateOT = useCallback(() => {
    if(selectionModel.length === 0) { 
      alertError("กรุณาเลือกพนักงานขับรถ")
    }
    const postData = { DrvIds: selectionModel, SalDte: dayjs(filterData.SalDte).format("YYYY-MM-DD") }
    ax.post(branchApiNm.calculateOT, postData).then(value => {
      if (value.data) {
        setDataTable(addIdForDataGrid(value.data, 'DrvId'))
      }
    })
  }, [ax, filterData.SalDte, selectionModel])

  console.log("selectedField::", selectedField)
  useEffect(() => {
    getData({ ...initFilterData })
  }, [getData])

  
  return (
    <BoxFC height='100%'>
      <BoxFR>
        <AddButton onClick={handleAddDriverSalary}>เพิ่มรายชื่อพนักงานขับรถ</AddButton>
        <AddButton onClick={handleAddDriverSalaryFromLastMonth}>เพิ่มข้อมูลจากเดือนก่อนหน้า</AddButton>
        <Button variant='contained' onClick={handleCalculateOT}><CalculateRounded sx={{mr: 1}}/> คำนวณล่วงเวลา</Button>
        {/* <Button variant='contained' onClick={() => { setDialogDiverSalaryMasterOpen(true) }}>กำหนดค่าเริ่มต้น พขร</Button>
        <Button variant='contained' onClick={handleGetDriverMaster}>
          <CloudDownloadRounded sx={{ mr: 1 }} />ดึงข้อมูลค่าเริ่มต้น
        </Button> */}
        <Box flex={1} />
        <ComboBox sx={{ width: 150 }} options={msData.driverOnlyCombo} label="พนักงานขับรถ"
          selectedId={filterData.DrvId}
          setSelectedId={(id) => setFilterData(o => ({ ...o, DrvId: id }))}
        />
        <DesktopDatePicker {...monthPickerProp} />
        <SearchButton onClick={(() => getData(filterData))} />
        <ClearButton onClick={(() => setFilterData({ ...clearFilterData }))} />
      </BoxFR>
      <Box height='100%' sx={{ ...sxSumColorClass, "& .col-red": { bgcolor: red[100] } }}>
        <DataGridCellExpand
          experimentalFeatures={{ rowPinning: true }}
          checkboxSelection
          selectionModel={selectionModel}
          onSelectionModelChange={(newSelectionModel) => {
            setSelectionModel(newSelectionModel);
          }}
          hideFooter
          rows={modDataTable}
          columns={columns}
          onCellClick={handleCellClick}
          onCellEditCommit={handleCellEditCommit}
          pinnedRows={{ bottom: [modDataTable.find(row => row.id === 0)] }}
          getRowClassName={getSumColorClassName}
          initialState={{
            pinnedColumns: {
              left: [GRID_CHECKBOX_SELECTION_COL_DEF.field, 'ShowDetail', 'No', 'DrvCd', 'DrvNm'],
            },
          }}
        />
      </Box>
      <DriverSalaryMasterDialog
        dialogOpen={dialogDiverSalaryMasterOpen}
        setDialogOpen={setDialogDiverSalaryMasterOpen} />

      {/* <TextFieldDialog title={`ระบุ ${salaryDriverColNm[selectedField]}`}
        label={["OthDscp", "DeOthDscp", "Rmk"].includes(selectedField) ? "ข้อความ" : "จำนวน"}
        type={["OthDscp", "DeOthDscp", "Rmk"].includes(selectedField) ? "text" : "number"}
        oldData={selectedRow ? selectedRow[selectedField] : null} dialogOpen={dialogTextFieldOpen}
        setDialogOpen={setDialogTextFieldOpen} onFinish={onTextFieldDialogFinish} /> */}

      <DriverSalaryDetailDialog
        dialogOpen={dialogDriverSalaryDetailOpen}
        setDialogOpen={setDialogDriverSalaryDetailOpen}
        drvId={selectedRow?.id}
        salDte={filterData.SalDte} />
      <AddDriverSalaryDialog
        exDrvIds={dataTable.map(row => row.DrvId)}
        dialogOpen={dialogAddDriverSalaryOpen}
        setDialogOpen={setDialogAddDriverSalaryOpen}
        onFinish={onAddDialogFinish} 
        lastFilter={lastFilter}/>
    </BoxFC>
  );
}

export default DriverSalary